import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {WorkflowModel, WorkflowState} from '../../../../workflow/models/workflow.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {take, takeUntil} from 'rxjs/operators';
import {QueryModel} from '@shared/models/query-model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Configuration} from '@shared/models/configuration';
import {AddParticipantToContactCommand} from '../../../commands/survey.commands';
import {WorkflowWizardComponent} from '../../../../workflow/components/workflow-wizard/workflow-wizard.component';
import {Observable, Subject} from 'rxjs';
import {IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
@Component({
    standalone: false,
    selector: 'particle-select-participants-step',
  templateUrl: './select-participants-step.component.html',
  styleUrls: ['./select-participants-step.component.scss']
})
export class SelectParticipantsStepComponent implements OnInit, IWorkflowStepComponent {
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  private workflow: WorkflowModel;
  private currentStep: WorkflowState;
  private reportId: any;
  queryModels: QueryModel[] = [];
  genericReportByIdKey = 'GenericReportById';
  ngUnsubscribe: Subject<void> = new Subject<void>();
  private report: any;
  private response$: any;
  private excutionId: string;
  private wizard: WorkflowWizardComponent;
  constructor(public changeDetectorRef: ChangeDetectorRef, private dialogService: DialogService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private queryStore: Store<IQueryState>) {
    this.sourceKey = 'ParticipantsForReportFieldSectionChoice';
    this.invalidateSubject = new InvalidateSubject();

  }

  ngOnInit() {

  }
  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
    const reportTaskInput = this.currentStep.Inputs.find(o => o.Name === 'ReportTaskId');
    this.excutionId = reportTaskInput.Value;
    const entitySelectorLeft = Configuration.getSmartGridConfig(this.sourceKey);
    entitySelectorLeft.Parameters['EXECUTION_ID'] = this.excutionId;
    this.invalidateSubject.invalidate();
  }
  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'AddToContact':
          const command = new AddParticipantToContactCommand(event.item.id);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
            console.log('AddCommandState', state);
            this.fuseSplashScreenService.hide();
            this.invalidateSubject.invalidate();
          },error=>{
            this.fuseSplashScreenService.hide();
          });
          break;
      }
    }
  }

  canCancel(): boolean {
    return true;
  }

  canMoveNext(): boolean {
    return true;
  }

  canMoveNext$(): Observable<boolean> {
    return null;
  }
}
